import { DividerProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: DividerProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as DividerProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      hasFlexboxContainer: true,
    } as DividerProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
